

import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { useQueryClient } from "@tanstack/react-query";
import type { StoreSubscriptionAssignmentView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminStoreSubscriptions } from "@/lib/query/core/invalidation";

type AssignStoreSubscriptionInput = {
  storeId: string;
  planId: string;
  startDate?: string;
  overrideAmount?: number;
  overridePeriodDays?: number;
};

export function useAssignStoreSubscriptionMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ storeId, ...body }: AssignStoreSubscriptionInput) =>
      apiJsonClient<StoreSubscriptionAssignmentView>(
        endpoints.admin.storeSubscriptionAssignments(storeId),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      ),
    onSuccess: async (_data, variables) => {
      await invalidateAdminStoreSubscriptions(queryClient, variables.storeId);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
